import { render, staticRenderFns } from "./ConsentFormDialog.vue?vue&type=template&id=463ec97c&scoped=true&"
import script from "./ConsentFormDialog.vue?vue&type=script&lang=js&"
export * from "./ConsentFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ec97c",
  null
  
)

export default component.exports